const ShareLinkIcon = ({
  height,
  width,
  fill = "#4361EE",
}: {
  height?: string;
  width?: string;
  fill?: string;
}) => {
  return (
    <svg
      width={width || "20"}
      height={height || "21"}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3531_46852)">
        <path
          d="M15.3034 13.4456L14.125 12.2656L15.3034 11.0872C15.6931 10.7009 16.0026 10.2415 16.2143 9.73522C16.4259 9.22897 16.5355 8.6859 16.5367 8.1372C16.5379 7.58849 16.4307 7.04494 16.2213 6.53777C16.0118 6.0306 15.7043 5.56979 15.3163 5.18179C14.9283 4.7938 14.4675 4.48626 13.9603 4.27683C13.4531 4.0674 12.9096 3.96021 12.3609 3.96142C11.8122 3.96262 11.2691 4.07219 10.7629 4.28383C10.2566 4.49548 9.79716 4.80503 9.41086 5.19472L8.23253 6.37389L7.05336 5.19556L8.23336 4.01722C9.32738 2.92321 10.8112 2.30859 12.3584 2.30859C13.9055 2.30859 15.3893 2.92321 16.4834 4.01722C17.5774 5.11124 18.192 6.59505 18.192 8.14222C18.192 9.6894 17.5774 11.1732 16.4834 12.2672L15.3042 13.4456H15.3034ZM12.9467 15.8022L11.7675 16.9806C10.6735 18.0746 9.18971 18.6892 7.64253 18.6892C6.09536 18.6892 4.61155 18.0746 3.51753 16.9806C2.42351 15.8865 1.8089 14.4027 1.8089 12.8556C1.8089 11.3084 2.42351 9.82458 3.51753 8.73056L4.6967 7.55222L5.87503 8.73222L4.6967 9.91056C4.307 10.2969 3.99745 10.7563 3.7858 11.2626C3.57416 11.7688 3.46459 12.3119 3.46339 12.8606C3.46219 13.4093 3.56937 13.9528 3.7788 14.46C3.98823 14.9672 4.29577 15.428 4.68377 15.816C5.07176 16.204 5.53257 16.5115 6.03974 16.721C6.54692 16.9304 7.09046 17.0376 7.63917 17.0364C8.18788 17.0352 8.73094 16.9256 9.23719 16.714C9.74344 16.5023 10.2029 16.1927 10.5892 15.8031L11.7675 14.6247L12.9467 15.8031V15.8022ZM12.3567 6.96306L13.5359 8.14222L7.64336 14.0339L6.4642 12.8556L12.3567 6.96389V6.96306Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_3531_46852">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ShareLinkIcon;
